import qs from "qs";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { FormGroup, Modal, ModalBody } from "reactstrap";
import { Col, Icon } from "../component/Component";
import Editor from "../component/Editor";
import axiosInstance from "../utils/axios";

export default function EditCampaign() {
  let { id } = useParams();

  const [categories, setCategories] = useState([]);
  const [campId, setCampId] = useState("");
  const [campTitle, setCampTitle] = useState("");
  const [campType, setCampType] = useState("");
  const [campEmail, setCampEmail] = useState("");
  const [campStartDate, setCampStartDate] = useState("");
  const [campEndDate, setCampEndDate] = useState("");
  const [campAmount, setCampAmount] = useState("");
  const [campStory, setCampStory] = useState("");
  const [campRef, setCampRef] = useState("");
  const [campStatus, setCampStatus] = useState("");
  const [campGoal, setCampGoal] = useState("");
  const [campCategory, setCampCategory] = useState("");
  const [modal, setModal] = useState({
    add: true,
  });

  // useEffect(() => {
  //   axiosInstance.get(`full_campaign/${id}`).then((res) => {
  //     setCampId(res.data.result[0].CampaignID);
  //     setCampTitle(res.data.result[0].title);
  //     setCampType(res.data.result[0].Campaign_Type);
  //     setCampEmail(res.data.result[0].email);
  //     setCampStartDate(res.data.result[0].start_date);
  //     setCampEndDate(res.data.result[0].end_date);
  //     setCampAmount(res.data.result[0].amount);
  //     setCampRef(res.data.result[0].reference_letter);
  //     setCampStory(res.data.result[0].campaign_story);
  //     setCampStatus(res.data.result[0].admin_status);
  //     setCampGoal(res.data.result[0].goals);
  //   });
  // }, [id]);

  // useEffect(() => {
  //   if (!id) return;

  //   const payload = new URLSearchParams();
  //   payload.append("campaign_reference", id);

  //   axiosInstance.get("needy_category").then((res) => {
  //     if (res.data.status_code === "0") {
  //       setCategories(res.data.result);
  //     } else {
  //       console.error("Failed to fetch categories:", res.data.message);
  //     }
  //   });

  //   axiosInstance
  //     .post("full_campaigns", payload, {
  //       headers: { "Content-Type": "application/x-www-form-urlencoded" },
  //     })
  //     .then((res) => {
  //       const result = Array.isArray(res.data?.result) ? res.data.result : [];
  //       if (result.length === 0) {
  //         console.warn("No campaign found for this ID");
  //         return;
  //       }
  //       const campaign = result[0];

  //       const toISODate = (d) => {
  //         const date = new Date(d);
  //         return isNaN(date.getTime()) ? "" : date.toISOString().split("T")[0];
  //       };

  //       setCampId(campaign.CampaignID);
  //       setCampTitle(campaign.title);
  //       setCampType(campaign.Campaign_Type);
  //       setCampEmail(campaign.email);
  //       setCampStartDate(toISODate(campaign.start_date));
  //       setCampEndDate(toISODate(campaign.end_date));
  //       setCampAmount(campaign.amount);
  //       setCampRef(campaign.reference_letter);
  //       setCampStory(campaign.campaign_story);
  //       setCampStatus(campaign.admin_status);
  //       setCampGoal(campaign.goals);
  //       setCampCategory(campaign.category || "");
  //     })
  //     .catch((err) => console.error("Fetch failed:", err));
  // }, [id]);

  useEffect(() => {
    if (!id) return;

    const fetchData = async () => {
      try {
        // 1. Fetch categories first
        const catRes = await axiosInstance.get("needy_category");
        if (catRes.data.status_code === "0") {
          setCategories(catRes.data.result);
        }

        // 2. Fetch campaign data
        const payload = new URLSearchParams();
        payload.append("campaign_reference", id);

        const campaignRes = await axiosInstance.post(
          "full_campaigns",
          payload,
          {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          }
        );

        const result = Array.isArray(campaignRes.data?.result)
          ? campaignRes.data.result
          : [];

        if (result.length === 0) {
          console.warn("No campaign found for this ID");
          return;
        }

        const campaign = result[0];

        const toISODate = (d) => {
          const date = new Date(d);
          return isNaN(date.getTime()) ? "" : date.toISOString().split("T")[0];
        };

        setCampId(campaign.CampaignID);
        setCampTitle(campaign.title);
        setCampType(campaign.Campaign_Type);
        setCampEmail(campaign.email);
        setCampStartDate(toISODate(campaign.start_date));
        setCampEndDate(toISODate(campaign.end_date));
        setCampAmount(campaign.amount);
        setCampRef(campaign.reference_letter);
        setCampStory(campaign.campaign_story);
        setCampStatus(campaign.admin_status);
        setCampGoal(campaign.goals);

        // 🔁 3. Convert category name to ID
        const matchedCategory = catRes.data.result.find(
          (c) => c.category === campaign.category
        );
        setCampCategory(matchedCategory?.needy_category_id || "");
      } catch (err) {
        console.error("Failed to load campaign or categories", err);
      }
    };

    fetchData();
  }, [id]);

  const updateStatus = async (email, campaign_reference, status) => {
    try {
      const response = await axiosInstance.post(
        "update_campaign_status",
        qs.stringify({
          email,
          campaign_reference,
          status,
        }),
        {
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        }
      );

      if (response.data.status_code === "0") {
        toast.success("Campaign status updated successfully");
      } else {
        toast.error(response.data.message || "Failed to update status");
      }
    } catch (error) {
      toast.error("An error occurred while updating status");
      console.error("Status update error:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axiosInstance.post(
        "update_campaigns",
        qs.stringify({
          email: campEmail,
          campaign_reference: campId,
          amount: campAmount,
          campaign_story: campStory,
          title: campTitle,
          start_date: campStartDate,
          end_date: campEndDate,
          status: campStatus,
          needy_category_id: campCategory,
          goals: campGoal,
        })
      );

      if (response.data["status_code"] === "0") {
        toast.success(response.data.message);
        // window.location.href = "/campaign";
        setModal({ add: false });
      } else {
        console.log(toast.error(response.data.message));
      }
    } catch (e) {
      toast.error(e.response);
    }
  };

  return (
    <div>
      <Modal
        isOpen={modal.add}
        toggle={() => setModal({ add: true })}
        className="modal-dialog-centered 80vh"
        size="lg"
      >
        <ModalBody>
          <Link to="/campaign" className="close">
            <Icon name="cross-sm"></Icon>
          </Link>
          <div className="p-2">
            <h1 className="pb-3 text-center text-gray-500 title">
              {" "}
              {campType} Campaign
            </h1>

            <div className="overflow-y-auto ">
              <h3 className="pb-3 "> Campaign ID : {campId}</h3>
              <h3 className="pb-3 ">Campaign Type : {campType}</h3>
              <h3 className="pb-3 "> Campaign Title : {campTitle}</h3>
              <h3 className="pb-3 "> Campaign Email : {campEmail}</h3>
              <h3 className="pb-3 "> Campaign Start Date : {campStartDate}</h3>
              <h3 className="pb-3 "> Campaign End Date : {campEndDate}</h3>
              <h3 className="pb-3 "> Campaign Amount : {campAmount}</h3>
              <h3 className="pb-3 "> Campaign reason : {campStory}</h3>
              <h3 className="pb-3 "> Campaign goal : {campGoal}</h3>
              <h5 className="mt-3 mb-3 text-center text-green-900 ">
                {" "}
                Edit Campaign
              </h5>
              <form onSubmit={handleSubmit} className="mt-4 row gy-4">
                <Col md="12">
                  <FormGroup>
                    <label className="mb-1">Campaign Reference</label>
                    <input
                      className="bg-gray-100 rounded-md form-control input-round"
                      required
                      type="text"
                      value={campId}
                      disabled
                    />
                  </FormGroup>
                </Col>
                <Col md="12">
                  <FormGroup>
                    <label className="mb-1">Email</label>
                    <input
                      className="bg-gray-100 rounded-md form-control input-round"
                      value={campEmail}
                      onChange={(e) => setCampEmail(e.target.value)}
                      required
                      type="text"
                    />
                  </FormGroup>
                </Col>
                <Col md="12">
                  <FormGroup>
                    <label className="mb-1">Amount</label>
                    <input
                      className="bg-gray-100 rounded-md form-control input-round"
                      value={campAmount}
                      onChange={(e) => setCampAmount(e.target.value)}
                      required
                      type="text"
                    />
                  </FormGroup>
                </Col>
                <Col md="12">
                  <FormGroup>
                    <label className="mb-1">Campaign Goal</label>
                    <input
                      className="bg-gray-100 rounded-md form-control input-round"
                      value={campGoal}
                      onChange={(e) => setCampGoal(e.target.value)}
                      required
                      type="text"
                    />
                  </FormGroup>
                </Col>
                <Col md="12">
                  <FormGroup>
                    <label className="mb-1">Campaign Category</label>
                    <select
                      className="bg-gray-100 rounded-md form-control input-round"
                      value={campCategory}
                      onChange={(e) => setCampCategory(e.target.value)}
                      required
                    >
                      <option value="">Select Category</option>
                      {categories.map((category) => (
                        <option
                          value={category.needy_category_id}
                          key={category.needy_category_id}
                        >
                          {category.category}
                        </option>
                      ))}
                    </select>
                  </FormGroup>
                </Col>
                <Col md="12">
                  <FormGroup>
                    <label className="mb-1">Campaign Status</label>
                    <select
                      className="bg-gray-100 rounded-md form-control input-round"
                      value={campStatus}
                      onChange={(e) => {
                        const newStatus = e.target.value;
                        setCampStatus(newStatus);
                        updateStatus(campEmail, campId, newStatus);
                      }}
                      required
                    >
                      <option value="">Change Status</option>
                      <option value="0">Active</option>
                      <option value="1">Pending</option>
                      <option value="4">Completed</option>
                    </select>
                  </FormGroup>
                </Col>
                <Col md="12">
                  <FormGroup>
                    <label className="mb-1">Campaign End Date</label>
                    <input
                      className="bg-gray-100 rounded-md form-control input-round"
                      value={campEndDate}
                      min={new Date().toISOString().split("T")[0]}
                      onChange={(e) => setCampEndDate(e.target.value)}
                      required
                      type="date"
                    />
                  </FormGroup>
                </Col>
                <Col md="12">
                  <FormGroup>
                    <label className="mb-1">Campaign Title</label>
                    <input
                      className="bg-gray-100 rounded-md form-control input-round"
                      value={campTitle}
                      onChange={(e) => setCampTitle(e.target.value)}
                      required
                      type="text"
                    />
                  </FormGroup>
                </Col>
                <Col md="12">
                  <FormGroup>
                    <label className="mb-1">Campaign Story</label>
                    {/* <textarea
                        className="bg-gray-100 rounded-md form-control input-round"
                        value={campStory}
                        onChange={(e) => setCampStory(e.target.value)}
                        cols="30"
                        rows="10"
                      ></textarea> */}
                    <Editor
                      value={campStory}
                      onChange={(value) => setCampStory(value)}
                    />
                  </FormGroup>
                </Col>
                <button
                  className="text-white bg-green-800 rounded-md form-control hover:bg-green-500"
                  type="submit"
                >
                  Submit
                </button>
              </form>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
}
